import { DeleteOutlined, InboxOutlined, PlusOutlined } from "@ant-design/icons";
import {
  Alert,
  Button,
  Card,
  Col,
  Form,
  Input,
  Popconfirm,
  Row,
  Spin,
  Upload,
} from "antd";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { ReactSortable } from "react-sortablejs";
import { upload_file } from "../../../services/uploads";
import { useParams } from "react-router-dom";

type Props = {
  form: any;
};

const SponsorPage = (props: Props) => {
  const { t } = useTranslation();
  const [fileLists, setFileLists] = useState<{ [key: string]: any[] }>({});
  const [uploadingspon, setUploadingspon] = useState(false);
  const [uploadingField, setUploadingField] = useState<Record<number, boolean>>(
    {}
  );
  const params = useParams();

  const getBase64 = (file: File, callback: (imageUrl: string) => void) => {
    const reader = new FileReader();
    reader.onload = () => callback(reader.result as string);
    reader.readAsDataURL(file);
  };

  return (
    <div className="add-task-body-layout">
      {/* sponsor page 6 */}

      <Form.List name="sponsor">
        {(fields, { add, remove }) => {
          const handleSortEnd = (sortedList: any) => {
            // อัปเดตตำแหน่ง fields ในฟอร์ม
            const sortedFields = sortedList.map((item: any) =>
              fields.find((field) => field.key === item.id)
            );

            // อัปเดตค่าฟอร์ม
            props.form.setFieldsValue({
              sponsor: sortedFields.map((field: any) =>
                props.form.getFieldValue(["sponsor", field.name])
              ),
            });

            // อัปเดต fileLists ตามลำดับใหม่
            const updatedFileLists: any = {};
            sortedFields.forEach(
              (field: { name: string | number }, index: string | number) => {
                updatedFileLists[index] = fileLists[field.name];
              }
            );

            setFileLists(updatedFileLists);
          };

          return (
            <>
              <ReactSortable
                list={fields.map((field) => ({
                  id: field.key, // ใช้ key เป็น id สำหรับ ReactSortable
                  ...field, // คัดลอกข้อมูลอื่น ๆ ใน field หากจำเป็น
                }))}
                setList={(newList) => handleSortEnd(newList)}
                animation={200}
              >
                {fields.map((field) => (
                  <Form.Item key={field.key} required={false}>
                    <Card
                      title={t("Sponsor")}
                      extra={
                        <Popconfirm
                          title={t(
                            "Are you sure you want to remove this sponsor"
                          )}
                          description={t("This information will be deleted")}
                          okText={t("confirm")}
                          cancelText={t("cancel")}
                          onConfirm={() => {
                            const currentSponsors =
                              props.form.getFieldValue("sponsor");
                            const updatedSponsors = currentSponsors.filter(
                              (_: any, index: number) => index !== field.name
                            );

                            // ✅ รีเซ็ต sponsor และอัปเดต form
                            setTimeout(() => {
                              props.form.setFieldsValue({
                                sponsor:
                                  updatedSponsors.length > 0
                                    ? [...updatedSponsors]
                                    : [],
                              });
                            }, 0);

                            // ✅ ล้างค่า fileLists ให้ React อัปเดต
                            setFileLists((prev) => {
                              const newFileLists = {
                                ...prev,
                              };
                              delete newFileLists[field.name]; // ✅ ลบรูปจาก fileLists
                              return { ...newFileLists }; // ✅ ทำให้ React อัปเดตค่าใหม่
                            });

                            // ✅ บังคับให้ Form อัปเดตค่า
                            setTimeout(() => {
                              props.form
                                .validateFields(["sponsor"])
                                .catch(() => {});
                            }, 100);
                          }}
                        >
                          <Button danger icon={<DeleteOutlined />} />
                        </Popconfirm>
                      }
                      style={{
                        width: "100%",
                        backgroundColor: "#F3F3F1",
                        borderColor: "#cccccc",
                      }}
                    >
                      <Alert
                        style={{ marginBottom: 20 }}
                        showIcon
                        message={`${t(
                          "The image size should be"
                        )} 400 * 150 ${t(
                          "The file size must not exceed"
                        )} 1 MB`}
                        type="info"
                        closable
                      />
                      {/* <Alert message="Warning Text" type="warning" /> */}
                      <Row gutter={16}>
                        <Col
                          xs={24}
                          sm={24}
                          md={10}
                          lg={10}
                          style={{ marginBottom: 10 }}
                        >
                          {/*  span={10} */}
                          <Upload.Dragger
                            name="file"
                            multiple={false}
                            listType="picture"
                            accept=".png, .jpeg, .jpg"
                            maxCount={1}
                            showUploadList={false}
                            style={{ borderRadius: 20 }}
                            fileList={fileLists[field.name] || []}
                            onChange={async (info) => {
                              const file = info.file.originFileObj || info.file;

                              if (!file) {
                                console.error("File is undefined");
                                return;
                              }

                              setUploadingspon(true); // เปิดใช้งาน loading state ทั้งหมด
                              setUploadingField((prev) => ({
                                ...prev,
                                [field.name]: true,
                              }));

                              const fileName = file.name;

                              try {
                                // Call API to upload the file
                                let uploadedImgUrl =
                                  props.form.getFieldValue("img");
                                const response = await upload_file({
                                  task_id: props.form.getFieldValue("task_id"),
                                  type: "sponsor_logo",
                                  name: fileName,
                                  file: file,
                                });

                                if (response.status === "success") {
                                  const imageUrl = response.link;

                                  // Update the logo field with the API response
                                  props.form.setFieldsValue({
                                    sponsor: props.form
                                      .getFieldValue("sponsor")
                                      .map((sponsor: any, index: number) =>
                                        index === field.name
                                          ? {
                                              ...sponsor,
                                              logo: imageUrl,
                                            }
                                          : sponsor
                                      ),
                                  });

                                  // Update the file list for preview
                                  const updatedFileList = [
                                    {
                                      uid: field.name,
                                      name: fileName,
                                      status: "done",
                                      url: imageUrl,
                                    },
                                  ];

                                  setFileLists((prev) => ({
                                    ...prev,
                                    [field.name]: updatedFileList,
                                  }));
                                } else {
                                  throw new Error(
                                    `File upload failed: ${JSON.stringify(
                                      response
                                    )}`
                                  );
                                }
                              } catch (error) {
                                console.error("Error uploading file:", error);
                              } finally {
                                setUploadingspon(false); // ปิด loading state ทั้งหมด
                                setUploadingField((prev) => ({
                                  ...prev,
                                  [field.name]: false,
                                })); // ปิด loading เฉพาะ field
                              }
                            }}
                            beforeUpload={(file) => {
                              getBase64(file, (imageUrl: string) => {
                                const updatedFileList = [
                                  {
                                    uid: field.name,
                                    name: file.name,
                                    status: "done",
                                    url: imageUrl,
                                  },
                                ];

                                // อัปเดต fileList เพื่อแสดงตัวอย่างชั่วคราว
                                setFileLists((prev) => ({
                                  ...prev,
                                  [field.name]: updatedFileList,
                                }));
                              });
                              return false; // ป้องกันการอัปโหลดอัตโนมัติ
                            }}
                          >
                            {uploadingField[field.name] ? (
                              <div
                                style={{
                                  textAlign: "center",
                                  padding: "10px",
                                }}
                              >
                                <Spin size="large" />
                                <p
                                  style={{
                                    marginTop: "10px",
                                  }}
                                >
                                  Uploading...
                                </p>
                              </div>
                            ) : fileLists[field.name]?.[0]?.url ||
                              (params.action === "edit" &&
                                props.form.getFieldValue([
                                  "sponsor",
                                  field.name,
                                  "logo",
                                ])) ? (
                              <div
                                style={{
                                  position: "relative",
                                  textAlign: "center",
                                }}
                              >
                                <img
                                  src={
                                    fileLists[field.name]?.[0]?.url
                                      ? `${process.env.REACT_APP_API}${
                                          fileLists[field.name]?.[0]?.url
                                        }`
                                      : `${
                                          process.env.REACT_APP_API
                                        }${props.form.getFieldValue([
                                          "sponsor",
                                          field.name,
                                          "logo",
                                        ])}`
                                  }
                                  alt="Preview"
                                  className="show-image"
                                />
                                {/* ปุ่มลบ */}
                              </div>
                            ) : (
                              <>
                                <p className="ant-upload-drag-icon">
                                  <InboxOutlined />
                                </p>
                                <p className="ant-upload-text">
                                  {t("Drag your image here, or browse")}
                                </p>
                                <p className="ant-upload-hint">
                                  {t(
                                    "Support Only PNG and JPEG files are allowed"
                                  )}
                                </p>
                              </>
                            )}
                          </Upload.Dragger>
                        </Col>
                        <Col xs={24} sm={24} md={14} lg={14}>
                          <Row>
                            <Col span={3}>
                              <span>{t("Name")} : </span>
                            </Col>
                            <Col span={20}>
                              <Form.Item
                                {...field}
                                name={[field.name, "name"]}
                                rules={[
                                  {
                                    required: true,
                                    message: "Please enter a name!",
                                  },
                                ]}
                                noStyle
                              >
                                <Input placeholder="Enter sponsor name" />
                              </Form.Item>
                            </Col>
                          </Row>
                          <Row gutter={16} style={{ marginTop: "10px" }}>
                            <Col span={3}>
                              <span>{t("URL")} : </span>
                            </Col>
                            <Col span={20}>
                              <Form.Item
                                {...field}
                                name={[field.name, "url"]}
                                rules={[
                                  {
                                    message: "Please enter a valid URL!",
                                  },
                                ]}
                                noStyle
                              >
                                <Input placeholder="https://example.com" />
                              </Form.Item>
                            </Col>
                          </Row>

                          <Row>
                            <Col span={3}></Col>
                            <Col span={20} style={{ marginTop: "10px" }}>
                              <Form.Item
                                {...field}
                                name={[field.name, "logo"]}
                                rules={[
                                  {
                                    required: true,
                                    message: "Please enter a name!",
                                  },
                                ]}
                                noStyle
                              >
                                <Input
                                  disabled
                                  placeholder="Enter sponsor name"
                                />
                              </Form.Item>
                            </Col>
                          </Row>

                          <Row gutter={16} style={{ marginTop: "10px" }}>
                            <Col span={3}>
                              <span></span>
                            </Col>
                            <Col>
                              {/* <Content> */}
                              {fileLists[field.name]?.[0]?.url ? (
                                <Button
                                  type="default"
                                  danger
                                  icon={<DeleteOutlined />}
                                  onClick={() => {
                                    setFileLists((prev) => ({
                                      ...prev,
                                      [field.name]: [],
                                    }));

                                    props.form.setFieldsValue({
                                      sponsor: props.form
                                        .getFieldValue("sponsor")
                                        .map((sponsor: any, index: number) =>
                                          index === field.name
                                            ? {
                                                ...sponsor,
                                                logo: null,
                                              }
                                            : sponsor
                                        ),
                                    });
                                  }}
                                >
                                  {t("Delete")}
                                </Button>
                              ) : (
                                <></>
                              )}
                              {/* </Content> */}
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    </Card>
                  </Form.Item>
                ))}
              </ReactSortable>
              <Form.Item>
                <Button
                  type="dashed"
                  onClick={() => {
                    add();
                    setTimeout(() => {
                      setFileLists((prev) => ({
                        ...prev,
                        [fields.length]: [],
                      }));
                    }, 0);
                  }}
                  icon={<PlusOutlined />}
                  style={{ width: "100%" }}
                >
                  {t("Add Sponsor")}
                </Button>
              </Form.Item>
            </>
          );
        }}
      </Form.List>
    </div>
  );
};

export default SponsorPage;
